import React, { memo, useContext } from 'react';
import { LanguageContext } from 'context/languageContext';

import { Image } from 'components';
import { linkYoutubeIcon } from 'assets/images';
import { linksSocial } from '../constants';

import styles from './styles.module.scss';

export const LinksSocialFooter = memo(() => {
  const { currentLanguage } = useContext(LanguageContext);

  let YoutubeUrl;
  switch (currentLanguage) {
    case 'en':
      YoutubeUrl = 'https://www.youtube.com/watch?v=Xu8zPF67yqM&list=PLv2bCnfMARBxAiJXFBCu8vJ_etMOykw-C';
      break;
    case 'de':
      YoutubeUrl = 'https://www.youtube.com/watch?v=YfKaFjHuh6s&list=PLv2bCnfMARBznjhpK4-itt7wNs6kTZR2R';
      break;
    case 'es':
      YoutubeUrl = 'https://www.youtube.com/watch?v=MNDUhuciGWM&list=PLv2bCnfMARBzBdVLFZgjzTQPDi5gX8mi_';
      break;
    case 'fr':
      YoutubeUrl = 'https://www.youtube.com/watch?v=6u5A9sHxKzE&list=PLv2bCnfMARByLKF3C0XnKEeaGJ9mKldAU';
      break;
    case 'it':
      YoutubeUrl = 'https://www.youtube.com/watch?v=brnGqIZCazE&list=PLv2bCnfMARByQWehmbt2mbQUFuM1QYe_i';
      break;
    case 'pt':
      YoutubeUrl = 'https://www.youtube.com/watch?v=mgWIewShN7k&list=PLv2bCnfMARBzD29EM3o67c4qU_zgxqn_7';
      break;
    case 'hy':
      YoutubeUrl = 'https://www.youtube.com/watch?v=biGwWGQLxGI&list=PLv2bCnfMARBwZk_oHN89HaCAJAVP2PTdV';
      break;
    case 'br':
      YoutubeUrl = 'https://www.youtube.com/watch?v=VRxsM7HmCWw&list=PLv2bCnfMARByKpiRtctcDxRioedALZhzI';
      break;
    default:
      break;
  }

  return (
    <div className={styles.footer_social}>
      {linksSocial.map(({ icon, link }, index) => (
        <a
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          href={link}
          target="_blank"
          rel="noreferrer"
          className={styles.footer_social_link}
        >
          <Image
            url={icon}
            className={styles.footer_social_link_icon}
          />
        </a>
      ))}
      <a
        href={YoutubeUrl}
        target="_blank"
        rel="noreferrer"
        className={styles.footer_social_link}
      >
        <Image
          url={linkYoutubeIcon}
          className={styles.footer_social_link_icon}
        />
      </a>
    </div>
  );
});
